module.exports = __webpack_public_path__ + "img/GALLERY-FRONX-BOOSTERGREEN-4.b08b823e.jpg";